/**
 * Rutas públicas (navegador) en español.
 * Las APIs `/api/v1/...` permanecen en inglés.
 */

const enc = (s) => encodeURIComponent(String(s))

export const paths = {
  home: '/',
  proximamente: '/proximamente',
  entrar: '/entrar',
  registro: '/registro',
  perfil: '/perfil',
  mapa: '/mapa',

  aventuras: '/aventuras',
  aventura: (slug) => `/aventura/${enc(slug)}`,
  aventuraCrear: (hanSlug) => `/aventura/crear/${enc(hanSlug)}`,
  aventuraResponder: (slug) => `/aventura/responder/${enc(slug)}`,

  hans: '/hans',
  han: (slug) => `/han/${enc(slug)}`,
  hanArchivos: (slug) => `/han/${enc(slug)}/archivos`,

  personajes: '/personajes',
  misPersonajes: '/mis-personajes',
  personajeCrear: '/personajes/crear',
  personaje: (slug) => `/personajes/${enc(slug)}`,
  personajeFicha: (slug) => `/personajes/${enc(slug)}/ficha`,
  personajeNpc: (slug) => `/personajes/${enc(slug)}/npc`,
  personajeTecnicas: (slug) => `/personajes/${enc(slug)}/tecnicas`,
  personajeEquipo: (slug) => `/personajes/${enc(slug)}/equipo`,
  personajeHistoria: (slug) => `/personajes/${enc(slug)}/historia`,
  personajeProgresion: (slug) => `/personajes/${enc(slug)}/progresion`,

  misiones: (id) => `/misiones/${enc(id)}`,
  clanes: '/clanes',
  clan: (idOrSlug) => `/clanes/${enc(idOrSlug)}`,
  sistemasDeRol: '/sistemas-de-rol',
  sistemaDeRol: (slug) => `/sistemas-de-rol/${enc(slug)}`,

  admin: '/admin',
}

/**
 * Redirects legacy (inglés) → español.
 * Cada entrada: { from, to } donde `to` puede ser string o función de params.
 */
export const LEGACY_REDIRECTS = [
  { from: '/auth/login', to: paths.entrar },
  { from: '/auth/register', to: paths.registro },
  { from: '/user/login', to: paths.entrar },
  { from: '/profile', to: paths.perfil },
  { from: '/map', to: paths.mapa },
  { from: '/adventures', to: paths.aventuras },
  { from: '/adventure/create/:slug', to: (p) => paths.aventuraCrear(p.slug) },
  { from: '/adventure/reply/:slug', to: (p) => paths.aventuraResponder(p.slug) },
  { from: '/adventure/:slug', to: (p) => paths.aventura(p.slug) },
  { from: '/territories', to: paths.hans },
  { from: '/territory/:slug/archivos', to: (p) => paths.hanArchivos(p.slug) },
  { from: '/territory/:slug', to: (p) => paths.han(p.slug) },
  { from: '/my-characters', to: paths.misPersonajes },
  { from: '/characters/create', to: paths.personajeCrear },
  { from: '/characters/:slug/npc', to: (p) => paths.personajeNpc(p.slug) },
  { from: '/characters/:slug/inventory', to: (p) => paths.personajeEquipo(p.slug) },
  { from: '/characters/:slug/ficha', to: (p) => paths.personajeFicha(p.slug) },
  { from: '/characters/:slug/tecnicas', to: (p) => paths.personajeTecnicas(p.slug) },
  { from: '/characters/:slug/equipo', to: (p) => paths.personajeEquipo(p.slug) },
  { from: '/characters/:slug/historia', to: (p) => paths.personajeHistoria(p.slug) },
  { from: '/characters/:slug/progresion', to: (p) => paths.personajeProgresion(p.slug) },
  { from: '/characters/:slug', to: (p) => paths.personaje(p.slug) },
  { from: '/characters', to: paths.personajes },
  { from: '/missions/:id', to: (p) => paths.misiones(p.id) },
  { from: '/clans/:idOrSlug', to: (p) => paths.clan(p.idOrSlug) },
  { from: '/clans', to: paths.clanes },
  { from: '/role-systems/:slug', to: (p) => paths.sistemaDeRol(p.slug) },
  { from: '/role-systems', to: paths.sistemasDeRol },
]

export default paths
